module.exports = __webpack_public_path__ + "static/media/ic_cotizacion_contado.2c42daec.svg";